module.exports = __webpack_public_path__ + "img/candidate.c47d2c94.svg";